import * as React from "react";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Stack,
} from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { Delete } from "../../../Component/api";

export default function DpaHapus(e) {
  function kembali() {
    e.refresh();
    e.setActivePage("tabel");
  }

  function handleProses() {
    Delete("tdpa", e.data).then(() => {
      kembali();
    });
  }

  return (
    <>
      <Card sx={{ background: "#ffffffaa", m: "20px" }}>
        <CardHeader
          title={
            <>
              <Box display="flex">
                <>Hapus</>
                <Box flexGrow={1} />
                <IconButton onClick={() => e.setActivePage("tabel")}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </>
          }
        />
        <Divider />
        <CardContent>
          <Stack gap="20px">
            <>
              <strong>
                Anda yakin ingin menghapus : <br />({e.data.kode}){" "}
                {e.data.uraian} ?
              </strong>
              <i>Data tidak dapat dikembalikan jika sudah dihapus</i>
            </>
            <Button
              sx={{ maxWidth: "150px" }}
              variant="contained"
              onClick={() => handleProses()}
            >
              Hapus
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
